(function ($) {
    'use strict';
    $(document).ready(function () {
        $('[data-content]')
            .popup({
                on: 'hover'
            })
        ;
    });
})(jQuery);